export default {
  SET_USER_INFO: 'userInfo/SET_USER_INFO',
  SET_REFERRAL_CODE: 'userInfo/SET_REFERRAL_CODE',
  VERIFY_EMAIL_SUCCESS: 'userInfo/VERIFY_EMAIL_SUCCESS',
  VERIFY_CAMPUS_EMAIL_SUCCESS: 'userInfo/VERIFY_CAMPUS_EMAIL_SUCCESS',
  SET_REFERRAL_REQUIRED: 'userInfo/SET_REFERRAL_REQUIRED',
  SET_ONBOARDING_STATUS: 'userInfo/SET_ONBOARDING_STATUS',
};
